import { render, staticRenderFns } from "./DetailSeries.vue?vue&type=template&id=5ad6cbf6&scoped=true&"
import script from "./DetailSeries.vue?vue&type=script&lang=js&"
export * from "./DetailSeries.vue?vue&type=script&lang=js&"
import style0 from "./DetailSeries.vue?vue&type=style&index=0&id=5ad6cbf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad6cbf6",
  null
  
)

export default component.exports